import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router';
import { withStyles, Grid, Link } from '@material-ui/core';
import {
    FHEWysiwyg,
    FHETitle,
    FHETextField,
    FHEContainerScroll,
    FHEContainerForm,
    FHEItemText,
    FormSaveButton,
    FHEReactSelect,
    FormEditButton
} from 'data/components';
import { SvgTicket } from 'data/common/iconsvg';
import memoizeOne from 'memoize-one';
import { tools } from 'data/common';

const moment = require('moment');

class FormIssue extends Component {
    static propTypes = {
        sendDataFunc: PropTypes.func.isRequired,
        renderOtherChildren: PropTypes.func,
        profile: PropTypes.object.isRequired,
        classes: PropTypes.object.isRequired,
        issue: PropTypes.object.isRequired,
        projects: PropTypes.array.isRequired,
        history: PropTypes.object.isRequired,
        type: PropTypes.string.isRequired
    };

    static defaultProps = {
        renderOtherChildren: null
    };

    constructor(props) {
        super(props);
        const { type } = props;
        this.state = {
            formDisabled: type === 'update',
            textInput_error: {},
            sendLoading: false,
            formIssue: this.getDataForm()
        };
    }
    getDataForm = () => {
        const { type, issue, projects } = this.props;
        return {
            title: type === 'update' ? issue.get('title') : null,
            project_id: type === 'update' ? issue.get('project_id') : null,
            createdAt: type === 'update' ? moment(issue.get('created_at')).format('DD/MM/YYYY HH:mm:ss') : null,
            state: type === 'update' ? issue.get('state') : null,
            projectName: type === 'update' ? projects.find(x => x.value === issue.get('project_id')).label : null,
            description: type === 'update' ? issue.get('description') : null,
            author: type === 'update' ? issue.get('author') : null
        };
    };

    loadInputs = () => {
        this.setState({
            formDisabled: true,
            sendLoading: false,
            formIssue: this.getDataForm()
        });
    };

    handleEdit = () => {
        const { formDisabled } = this.state;

        if (!formDisabled) this.loadInputs();
        this.setState({
            formDisabled: !formDisabled,
            textInput_error: {}
        });
    };

    handleChange = event => {
        const { formIssue, textInput_error } = this.state;

        this.setState({
            formIssue: { ...formIssue, [event.target.name]: event.target.value },
            textInput_error: { ...textInput_error, [event.target.name]: '' }
        });
    };

    isEmpty = value => {
        return value === null || /^\s*$/.test(value);
    };

    validateForm = () => {
        const { formIssue } = this.state;
        const { type } = this.props;

        const errors = {};

        if (this.isEmpty(formIssue.title)) errors['title'] = Translator.translate('general.fields.error.any.empty');
        if (this.isEmpty(formIssue.description)) errors['description'] = Translator.translate('general.fields.error.any.empty');

        if (type === 'create') {
            if (this.isEmpty(formIssue.project_id)) errors['project_id'] = Translator.translate('general.fields.error.any.empty');
        }

        this.setState({
            textInput_error: errors
        });

        return Object.keys(errors).length <= 0;
    };

    confirmEdit = () => {
        const { formIssue } = this.state;
        const { sendDataFunc } = this.props;

        if (!this.validateForm()) return false;

        this.setState({
            formDisabled: false,
            sendLoading: false
        });
        return sendDataFunc(formIssue)
            .then(() => this.loadInputs())
            .catch(error => {
                this.setState({
                    formDisabled: false,
                    sendLoading: false
                });
                if (error.validation && error.validation.errors) {
                    return this.handleFormError(error.validation.errors, Translator.translate('ticketsgit.issues.actions.updateError'));
                }
            });
    };

    createIssue = () => {
        const { formIssue } = this.state;
        const { sendDataFunc, profile, history } = this.props;

        if (!profile.get('admin') && !profile.getIn(['user_rights', history.environment]).includes('issueCreate')) return false;
        if (!this.validateForm()) return false;

        this.setState({
            formDisabled: true,
            sendLoading: true
        });
        return sendDataFunc(formIssue).catch(error => {
            this.setState({
                formDisabled: false,
                sendLoading: false
            });
            if (error.validation && error.validation.errors) {
                return this.handleFormError(error.validation.errors, Translator.translate('ticketsgit.issues.actions.createIssueError'));
            }
        });
    };

    renderButtonValidation = () => {
        const { formDisabled, sendLoading } = this.state;
        const { type, profile, history } = this.props;

        if (type === 'update') {
            const userRightUpdate = profile.get('admin') || profile.getIn(['user_rights', history.environment]).includes('issueUpdate');
            if (!userRightUpdate) return null;
            return (
                <FormEditButton formDisabled={formDisabled} handleEdit={this.handleEdit} confirmEdit={this.confirmEdit} sendLoading={sendLoading} />
            );
        }
        return <FormSaveButton sendFunc={this.createIssue} sendLoading={sendLoading} />;
    };

    handleEditor = data => {
        const { formIssue } = this.state;
        this.state.formIssue = { ...formIssue, description: data };
    };

    getSelectedProject = memoizeOne(project => {
        const { projects } = this.props;
        return projects.find(x => x.value === project);
    });

    handleReactSelect = (event, options) => {
        const { formIssue, textInput_error } = this.state;

        const newTextInput_error = tools.removeKey(textInput_error, options.name);

        this.setState({
            formIssue: { ...formIssue, [options.name]: event.value },
            textInput_error: newTextInput_error
        });
    };

    render() {
        const { textInput_error, formDisabled, formIssue } = this.state;
        const { type, projects, classes, issue, renderOtherChildren } = this.props;
        return (
            <Fragment>
                {type === 'update' ? (
                    <Link href={issue.get('web_url')} className={classes.link} target="_blank" rel="noopener">
                        <FHETitle title={issue.get('title')} Icon={SvgTicket} />
                    </Link>
                ) : (
                    <FHETitle title={Translator.translate('general.createIssue')} Icon={SvgTicket} />
                )}
                {this.renderButtonValidation()}
                <FHEContainerScroll>
                    <FHEContainerForm>
                        <Grid container spacing={3}>
                            <Grid container item sm={12} md={6} lg={4}>
                                <FHETextField
                                    disabled={formDisabled}
                                    id="title"
                                    value={formIssue.title}
                                    error={textInput_error.title}
                                    label={Translator.translate('general.table.column.title')}
                                    name="title"
                                    onChange={this.handleChange}
                                />
                            </Grid>

                            {type === 'update' ? (
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEItemText
                                        itemTitle={Translator.translate('general.table.column.projectName')}
                                        itemContent={
                                            projects.find(x => x.value === formIssue.project_id) === undefined
                                                ? ''
                                                : projects.find(x => x.value === formIssue.project_id).label
                                        }
                                    />
                                </Grid>
                            ) : (
                                <Grid container item sm={12} md={6} lg={4}>
                                    <FHEReactSelect
                                        name="project_id"
                                        label={Translator.translate('general.table.column.projectName')}
                                        onChange={this.handleReactSelect}
                                        value={this.getSelectedProject(formIssue.project_id)}
                                        choices={projects}
                                        error={textInput_error.project_id}
                                    />
                                </Grid>
                            )}

                            {type === 'update' && (
                                <Fragment>
                                    <Grid container item sm={12} md={6} lg={4}>
                                        <FHEItemText
                                            classContent={formIssue.state === 'opened' ? classes.openedColor : classes.closedColor}
                                            itemTitle={Translator.translate('general.table.column.issueState')}
                                            itemContent={Translator.translate(`ticketsgit.issues.table.state.${formIssue.state}`)}
                                        />
                                    </Grid>
                                    <Grid container item sm={12} md={6} lg={4}>
                                        <FHEItemText
                                            itemTitle={Translator.translate('general.table.column.author')}
                                            itemContent={formIssue.author === null ? '' : formIssue.author}
                                        />
                                    </Grid>
                                    <Grid container item sm={12} md={6} lg={4}>
                                        <FHEItemText
                                            itemTitle={Translator.translate('general.table.column.createdAt')}
                                            itemContent={formIssue.createdAt}
                                        />
                                    </Grid>
                                </Fragment>
                            )}

                            <Grid container item sm={12}>
                                <FHEWysiwyg
                                    markdown
                                    key={formDisabled}
                                    onChangeEditor={this.handleEditor}
                                    disabled={formDisabled}
                                    content={formIssue.description ? formIssue.description : ''}
                                    title={Translator.translate('general.table.column.message')}
                                    error={textInput_error.description}
                                />
                            </Grid>
                        </Grid>
                    </FHEContainerForm>
                    {renderOtherChildren && renderOtherChildren()}
                </FHEContainerScroll>
            </Fragment>
        );
    }
}

function mapStateToProps(state, props) {
    const { history } = props;

    const projectArray = state.environments[history.environment].data.Projects.get('list').reduce(
        (acc, project, key) => [...acc, { value: parseInt(key), label: project.get('name') }],
        []
    );

    const { issueId, projectId } = props.match.params;
    const issues = state.environments[history.environment].data.Issues.get('list');
    const issue = issues.find(
        issue => {
            return issue.get('project_id') === parseInt(projectId) && issue.get('iid') === parseInt(issueId);
        },
        null,
        new Map()
    );

    return {
        profile: state.data.user,
        issue,
        projects: projectArray
    };
}

const styles = theme => ({
    openedColor: {
        color: theme.palette.success.main
    },
    closedColor: {
        color: theme.palette.error.main
    },
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({}, dispatch)
    )(withStyles(styles, { withTheme: true })(FormIssue))
);



// WEBPACK FOOTER //
// ./environments/myfhe/scenes/Issues/form.js